import { useContext } from 'react'
import { ModalsContext } from 'contexts'

export default function useModals() {
  return useContext(ModalsContext)
}
